import Vue from 'vue'
import './pollyfills'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueRouterPrefetch from 'vue-router-prefetch'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import router from '@/routes/routes'
import {Table, TableColumn} from 'element-ui'
// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// router setup
import routes from './routes/routes'


// MIGRATED IMPORTS

//import router from './router'
import store from './store/'
import '@/components/App/firebaseInit.js';
import firebase from 'firebase'
import '@/components/App/firebaseInit'
//import vuetify from './plugins/vuetify';
import '@fortawesome/fontawesome-free/css/all.css'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/demo.scss'
import './assets/sass/custom.scss'

import sidebarLinks from './sidebarLinks'
import './registerServiceWorker'
// plugin setup
Vue.use(VueRouterPrefetch)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate)
Vue.use(Table)
Vue.use(TableColumn)
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
locale.use(lang)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
// configure router
/*const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})*/

let app
firebase.auth().onAuthStateChanged(()=>{
  //console.log("USER", user)
  if (!app){
    app = new Vue({
      router,
      store,
    //  vuetify,
      render: h => h(App)
    }).$mount('#app')
    
  }
})
/*Vue.use(vuetify, {
 iconfont: 'fa'
})*/

initProgress(router);

/* eslint-disable no-new */
/*new Vue({
  el: '#app',
  render: h => h(App),
  router
})*/
